module.exports = __webpack_public_path__ + "img/流体力学1_5_3.4f09e44e.jpg";